module.exports = __webpack_public_path__ + "img/ltkvideo-2x.5eb0f54.jpg";